import React from "react";
import he from "he";
import moment from "moment/moment";
import { Link } from "gatsby";
import ListCategories from "./list-categories";
import { CategoryUtils } from "../utils/CategoryUtils";
import { CategoryColor } from "../utils/CategoryColor";
import BookmarkButton from "./bookmark-button";
// import { useState } from "react";
// import { useEffect } from "react";
import {
  ApolloClient,
  createHttpLink,
  gql,
  InMemoryCache,
} from "@apollo/client";
// import Loading from "../components/loading";

// {
//     author: "Alessandro Di Stefano"
//     author_image: "https://startupitalia.eu/wp-content/uploads/sites/10/2018/09/distefano.png"
//     content: "<p>L&#8217;Italia porterà il <strong>David di Michelangelo</strong> all&#8217;Expo di Dubai. O, per lo meno, il suo gemello digitale in 3D. La Divisione Commerciale Italia di <strong>Hexagon</strong>, che ha siglato un contratto di sponsorizzazione con il Commissariato Generale di Sezione per la partecipazione italiana all’Esposizione Universale, è stata selezionata dall’Università di Firenze per la prima fase del progetto di riproduzione in scala reale del capolavoro di <strong>Michelangelo Buonarrot</strong>i. L&#8217;esposizione universale, che avrebbe dovuto tenersi proprio in questi mesi, è stata posticipata a causa della pandemia: la manifestazione avrà inizio il primo ottobre e terminerà il 31 marzo 2022.</p>↵<h3 style="text-align: center;">Leggi anche: <a href="https://startupitalia.eu/142290-20201130-la-pandemia-non-ferma-expo-tutta-la-tecnologia-antivirus-padiglione-italia" target="_blank" rel="noopener">La pandemia non ferma Expo. Tutta la tecnologia antivirus al Padiglione Italia</a></h3>↵<a href="https://thenexttech.startupitalia.eu/wp-content/uploads/sites/10/2021/01/David-5-scaled.jpg"><img loading="lazy" width="1536" height="1028" class="alignnone size-full wp-image-85658" src="https://thenexttech.startupitalia.eu/wp-content/uploads/sites/10/2021/01/David-5-scaled.jpg" alt="" srcset="https://cdn.startupitalia.eu/wp-content/uploads/sites/10/2021/01/22152454/David-5-scaled.jpg 1536w, https://cdn.startupitalia.eu/wp-content/uploads/sites/10/2021/01/22152454/David-5-300x201.jpg 300w, https://cdn.startupitalia.eu/wp-content/uploads/sites/10/2021/01/22152454/David-5-1024x685.jpg 1024w, https://cdn.startupitalia.eu/wp-content/uploads/sites/10/2021/01/22152454/David-5-768x514.jpg 768w, https://cdn.startupitalia.eu/wp-content/uploads/sites/10/2021/01/22152454/David-5-2048x1370.jpg 2048w" sizes="(max-width: 1536px) 100vw, 1536px" /></a>↵<h2>David, sei proprio tu?</h2>↵<p>I tecnici di <a href="https://www.hexagonmi.com/it-it" target="_blank" rel="noopener"><strong>Hexagon Italia</strong></a> stanno eseguendo le scansioni per realizzare il gemello digitale del David di Michelangelo, che sarà successivamente utilizzato per produrre una copia fisica di altissima definizione e precisione. La digitalizzazione viene eseguita con due diversi strumenti, un <strong>laser tracker</strong> <strong>Leica Absolute</strong> <strong>Tracker AT960</strong> e uno scanner a luce strutturata <strong>StereoScan Neo</strong>. Sotto la curatela scientifica dell’Università di Firenze, il valore del progetto sarà reso visibile nei diversi passaggi: dal processo di acquisizione digitale dei dati fino alla fresatura del materiale plastico che vi darà forma e che nei prossimi mesi vedrà impegnati scienziati, tecnici, curatori, artigiani, docenti e studenti universitari. La copia fisica ricavata dai dati raccolti sarà rifinita esteticamente da maestri restauratori ed infine trasportata a <strong>Dubai</strong> per essere esposta all’interno del Teatro della Memoria del <strong>Padiglione Italia</strong>.</p>↵<h3 style="text-align: center;">Leggi anche: <a href="https://thenexttech.startupitalia.eu/74339-20191015-il-ponte-di-leonardo-starebbe-in-piedi-e-sarebbe-stato-il-piu-lungo-al-mondo" target="_blank" rel="noopener">Il ponte di Leonardo starebbe in piedi. E sarebbe stato il più lungo al mondo</a></h3>↵<a href="https://thenexttech.startupitalia.eu/wp-content/uploads/sites/10/2021/01/David-6-scaled.jpg"><img loading="lazy" width="1536" height="1024" class="alignnone size-full wp-image-85659" src="https://thenexttech.startupitalia.eu/wp-content/uploads/sites/10/2021/01/David-6-scaled.jpg" alt="" srcset="https://cdn.startupitalia.eu/wp-content/uploads/sites/10/2021/01/22152544/David-6-scaled.jpg 1536w, https://cdn.startupitalia.eu/wp-content/uploads/sites/10/2021/01/22152544/David-6-300x200.jpg 300w, https://cdn.startupitalia.eu/wp-content/uploads/sites/10/2021/01/22152544/David-6-1024x683.jpg 1024w, https://cdn.startupitalia.eu/wp-content/uploads/sites/10/2021/01/22152544/David-6-768x512.jpg 768w, https://cdn.startupitalia.eu/wp-content/uploads/sites/10/2021/01/22152544/David-6-2048x1366.jpg 2048w" sizes="(max-width: 1536px) 100vw, 1536px" /></a>↵<p>«Hexagon Italia &#8211; ha dichiarato <strong>Cesare Cassani</strong>, responsabile Sistemi di Misura Portatili e Automazione della Divisione Commerciale Italia &#8211; è orgogliosa e onorata di essere stata selezionata per questo importante progetto, che non solo ha una grande rilevanza tecnologica e di immagine, ma che sarà di spunto per l’applicazione di tecnologie comunemente utilizzate in ambito industriale anche nel campo della tutela dei beni culturali e della ricerca scientifica, contribuendo in questo modo alla divulgazione e allo studio del patrimonio artistico del nostro Paese».</p>↵<h3 style="text-align: center;">Leggi anche: <a href="https://thenexttech.startupitalia.eu/72127-20190521-la-fisarmonica-leonardo-vinci-suona" target="_blank" rel="noopener">La fisarmonica di Leonardo Da Vinci suona di nuovo</a></h3>↵<a href="https://thenexttech.startupitalia.eu/wp-content/uploads/sites/10/2021/01/david-3.jpg"><img loading="lazy" width="789" height="603" class="size-full wp-image-85661 aligncenter" src="https://thenexttech.startupitalia.eu/wp-content/uploads/sites/10/2021/01/david-3.jpg" alt="" srcset="https://cdn.startupitalia.eu/wp-content/uploads/sites/10/2021/01/22152625/david-3.jpg 789w, https://cdn.startupitalia.eu/wp-content/uploads/sites/10/2021/01/22152625/david-3-300x229.jpg 300w, https://cdn.startupitalia.eu/wp-content/uploads/sites/10/2021/01/22152625/david-3-768x587.jpg 768w" sizes="(max-width: 789px) 100vw, 789px" /></a>↵<!-- AddThis Advanced Settings generic via filter on the_content --><!-- AddThis Share Buttons generic via filter on the_content -->"
//     date: "2021-01-22 15:40:50"
//     excerpt: "L&#039;esposizione universale parte il primo ottobre 2021. Al Padiglione Italia le nostre eccellenze tech"
//     featured_image: "https:/cdn.startupitalia.eu/wp-content/uploads/sites/10/2021/01/22152454/David-5-scaled.jpg"
//     id: 85657
//     title: "David di Michelangelo: il gemello digitale 3D in Erasmus all&#8217;Expo di Dubai"
//     url: "https://thenexttech.startupitalia.eu/85657-20210122-david-di-michelangelo-il-gemello-digitale-3d-in-erasmus-allexpo-di-dubai"
//     utime: "1611330050"
// }

class PostCardById extends React.Component {
  constructor(props) {
    console.warn("props", props);
    super(props);
    this.state = {
      data: {},
      isLoading: true,
      thereAreError: false,
      site: null,
      id: null,
      urlPathname: null,
      category: null,
    };
  }

  sources = {
    www: {
      url: "https://admin.startupitalia.eu/graphql",
    },
    impact: {
      url: "https://impact-admin.startupitalia.eu/graphql",
    },
    cybersecurity: {
      url: "https://cybersecurity-admin.startupitalia.eu/graphql",
    },
    ischool: {
      url: "https://ischool-admin.startupitalia.eu/graphql",
    },
    openinnovation: {
      url: "https://openinnovation-admin.startupitalia.eu/graphql",
    },
    smartworking: {
      url: "https://smartworking-admin.startupitalia.eu/graphql",
    },
    smartmoney: {
      url: "https://smartmoney-admin.startupitalia.eu/graphql",
    },
    sportup: {
      url: "https://sportup-admin.startupitalia.eu/graphql",
    },
    thefoodmakers: {
      url: "https://thefoodmakers-admin.startupitalia.eu/graphql",
    },
    thenexttech: {
      url: "https://thenexttech-admin.startupitalia.eu/graphql",
    },
    valoreresponsabile: {
      url: "https://valoreresponsabile-admin.startupitalia.eu/graphql",
    },
    life: {
      url: "https://life-admin.startupitalia.eu/graphql",
    },
  };

  graphql_query = gql`
    query GET_POST($id: ID!) {
      post(id: $id, idType: DATABASE_ID) {
        id
        postId
        title
        excerpt
        uri
        link
        date
        content
        template_file
        categoria_landing_img
        categoria_landing_text
        categoria_landing_link
        video_content
        video_embedded_home
        primary_category
        primary_category_link
        categories_json_array
        featuredImage {
          node {
            link
            guid
            mediaItemUrl
            srcSet
            sizes
          }
        }
        categories {
          nodes {
            id
            name
            slug
          }
        }
        tags {
          nodes {
            id
            slug
            name
          }
        }
        author {
          node {
            name
            avatar(size: 50) {
              url
            }
            slug
            description
          }
        }
        preview {
          node {
            id
            postId
            title
            excerpt
            uri
            link
            date
            content
            template_file
            categoria_landing_img
            categoria_landing_text
            categoria_landing_link
            video_content
            video_embedded_home
            primary_category
            primary_category_link
            categories_json_array
            featuredImage {
              node {
                link
                guid
                mediaItemUrl
                srcSet
                sizes
              }
            }
            categories {
              nodes {
                id
                name
                slug
              }
            }
            tags {
              nodes {
                id
                slug
                name
              }
            }
            author {
              node {
                name
                avatar(size: 50) {
                  url
                }
                slug
                description
              }
            }
          }
        }
      }
    }
  `;

  getData() {
    var gql_url = this.sources[this.props.site]["url"];
    const httpLink = createHttpLink({
      uri: gql_url,
    });
    const client = new ApolloClient({
      link: httpLink,
      cache: new InMemoryCache(),
    });

    client
      .query({ query: this.graphql_query, variables: { id: this.props.id } })
      .then((result) => {
        var _data = JSON.parse(JSON.stringify(result["data"])).post;
        if (_data) {
          // ? _data.primary_category
          // : _data.category_link.replace("category/", "")
          this.setState({
            isLoading: false,
            data: _data,
            urlPathname: new URL(_data.link),
            category: _data.primary_category,
          });
        } else {
          this.setState({
            isLoading: false,
            thereAreError: true,
            data: {},
          });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  componentDidMount() {
    this.setState({ isLoading: true });

    this.getData();
  }

  render() {
    return (
      <Link
        to={this?.state?.data?.link || ""}
        className="mag_big_post_container search_big_post_container"
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "1rem",
          borderBottom: "1px #B2B4CA solid",
        }}
      >
        {this.state.isLoading && (
          <div className="div-loading-card">LOADING..</div>
        )}

        {!this.state.isLoading && (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <div className="mag_big_post_single_category">
              {/* <Link to={`/category${this.state.data.category_slug ? '/' + new CategoryUtils(this.state.data.category_slug).link : this.state.data.category_link.replace('category/', '')}`}>{this.state.data.category}</Link> */}
              <Link
                style={{
                  color: new CategoryColor(this.state.data.primary_category)
                    .color,
                }}
                to={`${
                  new CategoryUtils(this.state.data.primary_category).link
                }`}
              >
                {this.state.data.primary_category}
              </Link>
            </div>
            <div role="button" tabIndex="0" style={{ marginLeft: "auto" }}>
              <BookmarkButton news_url={this.state.data.link} />
            </div>
          </div>
        )}
        {!this.state.isLoading && (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              height: "100%",
            }}
          >
            <div style={{ flex: 5, display: "flex", flexDirection: "column" }}>
              {/* <div>
            {this.state.data.url}
          </div> */}
              <div>
                <h2
                  style={{ marginRight: "1rem", height: "auto" }}
                  className={"textinitial mag_customnumcat_posts_title"}
                >
                  {he.decode(this.state.data.title)}
                </h2>
              </div>
              {(this.state.data.categories.nodes || []).length > 1 && (
                <div
                  className="entry-subcategories"
                  style={{
                    marginTop: "1rem",
                    marginBottom: "1rem",
                    display: "flex",
                    flexWrap: "wrap",
                  }}
                >
                  <ListCategories
                    categories={this.state.data.categories.nodes.slice(0, 3)}
                    primary_category={this.state.data.primary_category}
                  ></ListCategories>
                </div>
              )}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexGrow: "1",
                }}
              >
                <div
                  style={{ marginTop: "auto" }}
                  className={"mag_customnumcat_posts_author"}
                >
                  {this.state.data?.author?.node?.name}
                </div>
                {this.state.data.date && (
                  <div
                    style={{ marginTop: "auto" }}
                    className={"mag_customnumcat_posts_author"}
                  >
                    {moment(this.state.data.date).format("D MMM YY")}
                  </div>
                )}
              </div>
            </div>
            <div
              style={{
                flex: 1,
                display: "flex",
                marginLeft: "1rem",
              }}
            >
              <div
                className="search-result-img-container"
                style={{
                  width: "100%",
                  marginTop: "auto",
                  marginBottom: "auto",
                }}
              >
                <div
                  className="search-result-img"
                  style={{
                    paddingTop: "100%",
                    backgroundImage: `url('${
                      this.state.data?.featuredImage?.node?.mediaItemUrl || ""
                    }')`,
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                    borderRadius: "1rem",
                    marginTop: "auto",
                    marginBottom: "auto",
                  }}
                ></div>
              </div>
            </div>
          </div>
        )}
      </Link>
    );
  }
}

export default PostCardById;
